export default __webpack_public_path__ + "static/media/eight.5d55a1c2.jpg";